import { useEffect as Er, useReducer as Da, useRef as Aa, useCallback as La, useMemo as Ma } from "react";
import { c as N, g as Ra } from "./_commonjsHelpers-DaMA6jEr.mjs";
var z, Dr;
function Ga() {
  if (Dr) return z;
  Dr = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return z = e, z;
}
var W, Lr;
function Ca() {
  if (Lr) return W;
  Lr = 1;
  function e(r, t) {
    return r === t || r !== r && t !== t;
  }
  return W = e, W;
}
var $, Mr;
function F() {
  if (Mr) return $;
  Mr = 1;
  var e = Ca();
  function r(t, a) {
    for (var n = t.length; n--; )
      if (e(t[n][0], a))
        return n;
    return -1;
  }
  return $ = r, $;
}
var J, Gr;
function Ha() {
  if (Gr) return J;
  Gr = 1;
  var e = F(), r = Array.prototype, t = r.splice;
  function a(n) {
    var i = this.__data__, u = e(i, n);
    if (u < 0)
      return !1;
    var s = i.length - 1;
    return u == s ? i.pop() : t.call(i, u, 1), --this.size, !0;
  }
  return J = a, J;
}
var Q, Hr;
function Na() {
  if (Hr) return Q;
  Hr = 1;
  var e = F();
  function r(t) {
    var a = this.__data__, n = e(a, t);
    return n < 0 ? void 0 : a[n][1];
  }
  return Q = r, Q;
}
var V, Nr;
function Fa() {
  if (Nr) return V;
  Nr = 1;
  var e = F();
  function r(t) {
    return e(this.__data__, t) > -1;
  }
  return V = r, V;
}
var X, Fr;
function Ka() {
  if (Fr) return X;
  Fr = 1;
  var e = F();
  function r(t, a) {
    var n = this.__data__, i = e(n, t);
    return i < 0 ? (++this.size, n.push([t, a])) : n[i][1] = a, this;
  }
  return X = r, X;
}
var Y, Kr;
function K() {
  if (Kr) return Y;
  Kr = 1;
  var e = Ga(), r = Ha(), t = Na(), a = Fa(), n = Ka();
  function i(u) {
    var s = -1, c = u == null ? 0 : u.length;
    for (this.clear(); ++s < c; ) {
      var o = u[s];
      this.set(o[0], o[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = r, i.prototype.get = t, i.prototype.has = a, i.prototype.set = n, Y = i, Y;
}
var Z, kr;
function ka() {
  if (kr) return Z;
  kr = 1;
  var e = K();
  function r() {
    this.__data__ = new e(), this.size = 0;
  }
  return Z = r, Z;
}
var ee, Ur;
function Ua() {
  if (Ur) return ee;
  Ur = 1;
  function e(r) {
    var t = this.__data__, a = t.delete(r);
    return this.size = t.size, a;
  }
  return ee = e, ee;
}
var re, Br;
function Ba() {
  if (Br) return re;
  Br = 1;
  function e(r) {
    return this.__data__.get(r);
  }
  return re = e, re;
}
var te, zr;
function za() {
  if (zr) return te;
  zr = 1;
  function e(r) {
    return this.__data__.has(r);
  }
  return te = e, te;
}
var ae, Wr;
function Sa() {
  if (Wr) return ae;
  Wr = 1;
  var e = typeof N == "object" && N && N.Object === Object && N;
  return ae = e, ae;
}
var ne, $r;
function P() {
  if ($r) return ne;
  $r = 1;
  var e = Sa(), r = typeof self == "object" && self && self.Object === Object && self, t = e || r || Function("return this")();
  return ne = t, ne;
}
var ie, Jr;
function wr() {
  if (Jr) return ie;
  Jr = 1;
  var e = P(), r = e.Symbol;
  return ie = r, ie;
}
var ue, Qr;
function Wa() {
  if (Qr) return ue;
  Qr = 1;
  var e = wr(), r = Object.prototype, t = r.hasOwnProperty, a = r.toString, n = e ? e.toStringTag : void 0;
  function i(u) {
    var s = t.call(u, n), c = u[n];
    try {
      u[n] = void 0;
      var o = !0;
    } catch {
    }
    var _ = a.call(u);
    return o && (s ? u[n] = c : delete u[n]), _;
  }
  return ue = i, ue;
}
var se, Vr;
function $a() {
  if (Vr) return se;
  Vr = 1;
  var e = Object.prototype, r = e.toString;
  function t(a) {
    return r.call(a);
  }
  return se = t, se;
}
var oe, Xr;
function M() {
  if (Xr) return oe;
  Xr = 1;
  var e = wr(), r = Wa(), t = $a(), a = "[object Null]", n = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function u(s) {
    return s == null ? s === void 0 ? n : a : i && i in Object(s) ? r(s) : t(s);
  }
  return oe = u, oe;
}
var ce, Yr;
function k() {
  if (Yr) return ce;
  Yr = 1;
  function e(r) {
    var t = typeof r;
    return r != null && (t == "object" || t == "function");
  }
  return ce = e, ce;
}
var fe, Zr;
function Ia() {
  if (Zr) return fe;
  Zr = 1;
  var e = M(), r = k(), t = "[object AsyncFunction]", a = "[object Function]", n = "[object GeneratorFunction]", i = "[object Proxy]";
  function u(s) {
    if (!r(s))
      return !1;
    var c = e(s);
    return c == a || c == n || c == t || c == i;
  }
  return fe = u, fe;
}
var ve, et;
function Ja() {
  if (et) return ve;
  et = 1;
  var e = P(), r = e["__core-js_shared__"];
  return ve = r, ve;
}
var _e, rt;
function Qa() {
  if (rt) return _e;
  rt = 1;
  var e = Ja(), r = function() {
    var a = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return a ? "Symbol(src)_1." + a : "";
  }();
  function t(a) {
    return !!r && r in a;
  }
  return _e = t, _e;
}
var he, tt;
function Oa() {
  if (tt) return he;
  tt = 1;
  var e = Function.prototype, r = e.toString;
  function t(a) {
    if (a != null) {
      try {
        return r.call(a);
      } catch {
      }
      try {
        return a + "";
      } catch {
      }
    }
    return "";
  }
  return he = t, he;
}
var de, at;
function Va() {
  if (at) return de;
  at = 1;
  var e = Ia(), r = Qa(), t = k(), a = Oa(), n = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, u = Function.prototype, s = Object.prototype, c = u.toString, o = s.hasOwnProperty, _ = RegExp(
    "^" + c.call(o).replace(n, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(m) {
    if (!t(m) || r(m))
      return !1;
    var T = e(m) ? _ : i;
    return T.test(a(m));
  }
  return de = f, de;
}
var le, nt;
function Xa() {
  if (nt) return le;
  nt = 1;
  function e(r, t) {
    return r == null ? void 0 : r[t];
  }
  return le = e, le;
}
var pe, it;
function x() {
  if (it) return pe;
  it = 1;
  var e = Va(), r = Xa();
  function t(a, n) {
    var i = r(a, n);
    return e(i) ? i : void 0;
  }
  return pe = t, pe;
}
var ge, ut;
function Pr() {
  if (ut) return ge;
  ut = 1;
  var e = x(), r = P(), t = e(r, "Map");
  return ge = t, ge;
}
var ye, st;
function U() {
  if (st) return ye;
  st = 1;
  var e = x(), r = e(Object, "create");
  return ye = r, ye;
}
var be, ot;
function Ya() {
  if (ot) return be;
  ot = 1;
  var e = U();
  function r() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return be = r, be;
}
var qe, ct;
function Za() {
  if (ct) return qe;
  ct = 1;
  function e(r) {
    var t = this.has(r) && delete this.__data__[r];
    return this.size -= t ? 1 : 0, t;
  }
  return qe = e, qe;
}
var me, ft;
function en() {
  if (ft) return me;
  ft = 1;
  var e = U(), r = "__lodash_hash_undefined__", t = Object.prototype, a = t.hasOwnProperty;
  function n(i) {
    var u = this.__data__;
    if (e) {
      var s = u[i];
      return s === r ? void 0 : s;
    }
    return a.call(u, i) ? u[i] : void 0;
  }
  return me = n, me;
}
var Te, vt;
function rn() {
  if (vt) return Te;
  vt = 1;
  var e = U(), r = Object.prototype, t = r.hasOwnProperty;
  function a(n) {
    var i = this.__data__;
    return e ? i[n] !== void 0 : t.call(i, n);
  }
  return Te = a, Te;
}
var Ae, _t;
function tn() {
  if (_t) return Ae;
  _t = 1;
  var e = U(), r = "__lodash_hash_undefined__";
  function t(a, n) {
    var i = this.__data__;
    return this.size += this.has(a) ? 0 : 1, i[a] = e && n === void 0 ? r : n, this;
  }
  return Ae = t, Ae;
}
var Re, ht;
function an() {
  if (ht) return Re;
  ht = 1;
  var e = Ya(), r = Za(), t = en(), a = rn(), n = tn();
  function i(u) {
    var s = -1, c = u == null ? 0 : u.length;
    for (this.clear(); ++s < c; ) {
      var o = u[s];
      this.set(o[0], o[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = r, i.prototype.get = t, i.prototype.has = a, i.prototype.set = n, Re = i, Re;
}
var Ce, dt;
function nn() {
  if (dt) return Ce;
  dt = 1;
  var e = an(), r = K(), t = Pr();
  function a() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (t || r)(),
      string: new e()
    };
  }
  return Ce = a, Ce;
}
var Se, lt;
function un() {
  if (lt) return Se;
  lt = 1;
  function e(r) {
    var t = typeof r;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? r !== "__proto__" : r === null;
  }
  return Se = e, Se;
}
var Ie, pt;
function B() {
  if (pt) return Ie;
  pt = 1;
  var e = un();
  function r(t, a) {
    var n = t.__data__;
    return e(a) ? n[typeof a == "string" ? "string" : "hash"] : n.map;
  }
  return Ie = r, Ie;
}
var Oe, gt;
function sn() {
  if (gt) return Oe;
  gt = 1;
  var e = B();
  function r(t) {
    var a = e(this, t).delete(t);
    return this.size -= a ? 1 : 0, a;
  }
  return Oe = r, Oe;
}
var je, yt;
function on() {
  if (yt) return je;
  yt = 1;
  var e = B();
  function r(t) {
    return e(this, t).get(t);
  }
  return je = r, je;
}
var Ee, bt;
function cn() {
  if (bt) return Ee;
  bt = 1;
  var e = B();
  function r(t) {
    return e(this, t).has(t);
  }
  return Ee = r, Ee;
}
var we, qt;
function fn() {
  if (qt) return we;
  qt = 1;
  var e = B();
  function r(t, a) {
    var n = e(this, t), i = n.size;
    return n.set(t, a), this.size += n.size == i ? 0 : 1, this;
  }
  return we = r, we;
}
var Pe, mt;
function ja() {
  if (mt) return Pe;
  mt = 1;
  var e = nn(), r = sn(), t = on(), a = cn(), n = fn();
  function i(u) {
    var s = -1, c = u == null ? 0 : u.length;
    for (this.clear(); ++s < c; ) {
      var o = u[s];
      this.set(o[0], o[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = r, i.prototype.get = t, i.prototype.has = a, i.prototype.set = n, Pe = i, Pe;
}
var xe, Tt;
function vn() {
  if (Tt) return xe;
  Tt = 1;
  var e = K(), r = Pr(), t = ja(), a = 200;
  function n(i, u) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!r || c.length < a - 1)
        return c.push([i, u]), this.size = ++s.size, this;
      s = this.__data__ = new t(c);
    }
    return s.set(i, u), this.size = s.size, this;
  }
  return xe = n, xe;
}
var De, At;
function _n() {
  if (At) return De;
  At = 1;
  var e = K(), r = ka(), t = Ua(), a = Ba(), n = za(), i = vn();
  function u(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return u.prototype.clear = r, u.prototype.delete = t, u.prototype.get = a, u.prototype.has = n, u.prototype.set = i, De = u, De;
}
var Le, Rt;
function hn() {
  if (Rt) return Le;
  Rt = 1;
  var e = "__lodash_hash_undefined__";
  function r(t) {
    return this.__data__.set(t, e), this;
  }
  return Le = r, Le;
}
var Me, Ct;
function dn() {
  if (Ct) return Me;
  Ct = 1;
  function e(r) {
    return this.__data__.has(r);
  }
  return Me = e, Me;
}
var Ge, St;
function ln() {
  if (St) return Ge;
  St = 1;
  var e = ja(), r = hn(), t = dn();
  function a(n) {
    var i = -1, u = n == null ? 0 : n.length;
    for (this.__data__ = new e(); ++i < u; )
      this.add(n[i]);
  }
  return a.prototype.add = a.prototype.push = r, a.prototype.has = t, Ge = a, Ge;
}
var He, It;
function pn() {
  if (It) return He;
  It = 1;
  function e(r, t) {
    for (var a = -1, n = r == null ? 0 : r.length; ++a < n; )
      if (t(r[a], a, r))
        return !0;
    return !1;
  }
  return He = e, He;
}
var Ne, Ot;
function gn() {
  if (Ot) return Ne;
  Ot = 1;
  function e(r, t) {
    return r.has(t);
  }
  return Ne = e, Ne;
}
var Fe, jt;
function Ea() {
  if (jt) return Fe;
  jt = 1;
  var e = ln(), r = pn(), t = gn(), a = 1, n = 2;
  function i(u, s, c, o, _, f) {
    var m = c & a, T = u.length, A = s.length;
    if (T != A && !(m && A > T))
      return !1;
    var y = f.get(u), p = f.get(s);
    if (y && p)
      return y == s && p == u;
    var b = -1, v = !0, R = c & n ? new e() : void 0;
    for (f.set(u, s), f.set(s, u); ++b < T; ) {
      var h = u[b], C = s[b];
      if (o)
        var g = m ? o(C, h, b, s, u, f) : o(h, C, b, u, s, f);
      if (g !== void 0) {
        if (g)
          continue;
        v = !1;
        break;
      }
      if (R) {
        if (!r(s, function(d, S) {
          if (!t(R, S) && (h === d || _(h, d, c, o, f)))
            return R.push(S);
        })) {
          v = !1;
          break;
        }
      } else if (!(h === C || _(h, C, c, o, f))) {
        v = !1;
        break;
      }
    }
    return f.delete(u), f.delete(s), v;
  }
  return Fe = i, Fe;
}
var Ke, Et;
function yn() {
  if (Et) return Ke;
  Et = 1;
  var e = P(), r = e.Uint8Array;
  return Ke = r, Ke;
}
var ke, wt;
function bn() {
  if (wt) return ke;
  wt = 1;
  function e(r) {
    var t = -1, a = Array(r.size);
    return r.forEach(function(n, i) {
      a[++t] = [i, n];
    }), a;
  }
  return ke = e, ke;
}
var Ue, Pt;
function qn() {
  if (Pt) return Ue;
  Pt = 1;
  function e(r) {
    var t = -1, a = Array(r.size);
    return r.forEach(function(n) {
      a[++t] = n;
    }), a;
  }
  return Ue = e, Ue;
}
var Be, xt;
function mn() {
  if (xt) return Be;
  xt = 1;
  var e = wr(), r = yn(), t = Ca(), a = Ea(), n = bn(), i = qn(), u = 1, s = 2, c = "[object Boolean]", o = "[object Date]", _ = "[object Error]", f = "[object Map]", m = "[object Number]", T = "[object RegExp]", A = "[object Set]", y = "[object String]", p = "[object Symbol]", b = "[object ArrayBuffer]", v = "[object DataView]", R = e ? e.prototype : void 0, h = R ? R.valueOf : void 0;
  function C(g, d, S, I, j, l, O) {
    switch (S) {
      case v:
        if (g.byteLength != d.byteLength || g.byteOffset != d.byteOffset)
          return !1;
        g = g.buffer, d = d.buffer;
      case b:
        return !(g.byteLength != d.byteLength || !l(new r(g), new r(d)));
      case c:
      case o:
      case m:
        return t(+g, +d);
      case _:
        return g.name == d.name && g.message == d.message;
      case T:
      case y:
        return g == d + "";
      case f:
        var q = n;
      case A:
        var E = I & u;
        if (q || (q = i), g.size != d.size && !E)
          return !1;
        var w = O.get(g);
        if (w)
          return w == d;
        I |= s, O.set(g, d);
        var H = a(q(g), q(d), I, j, l, O);
        return O.delete(g), H;
      case p:
        if (h)
          return h.call(g) == h.call(d);
    }
    return !1;
  }
  return Be = C, Be;
}
var ze, Dt;
function Tn() {
  if (Dt) return ze;
  Dt = 1;
  function e(r, t) {
    for (var a = -1, n = t.length, i = r.length; ++a < n; )
      r[i + a] = t[a];
    return r;
  }
  return ze = e, ze;
}
var We, Lt;
function xr() {
  if (Lt) return We;
  Lt = 1;
  var e = Array.isArray;
  return We = e, We;
}
var $e, Mt;
function An() {
  if (Mt) return $e;
  Mt = 1;
  var e = Tn(), r = xr();
  function t(a, n, i) {
    var u = n(a);
    return r(a) ? u : e(u, i(a));
  }
  return $e = t, $e;
}
var Je, Gt;
function Rn() {
  if (Gt) return Je;
  Gt = 1;
  function e(r, t) {
    for (var a = -1, n = r == null ? 0 : r.length, i = 0, u = []; ++a < n; ) {
      var s = r[a];
      t(s, a, r) && (u[i++] = s);
    }
    return u;
  }
  return Je = e, Je;
}
var Qe, Ht;
function Cn() {
  if (Ht) return Qe;
  Ht = 1;
  function e() {
    return [];
  }
  return Qe = e, Qe;
}
var Ve, Nt;
function Sn() {
  if (Nt) return Ve;
  Nt = 1;
  var e = Rn(), r = Cn(), t = Object.prototype, a = t.propertyIsEnumerable, n = Object.getOwnPropertySymbols, i = n ? function(u) {
    return u == null ? [] : (u = Object(u), e(n(u), function(s) {
      return a.call(u, s);
    }));
  } : r;
  return Ve = i, Ve;
}
var Xe, Ft;
function In() {
  if (Ft) return Xe;
  Ft = 1;
  function e(r, t) {
    for (var a = -1, n = Array(r); ++a < r; )
      n[a] = t(a);
    return n;
  }
  return Xe = e, Xe;
}
var Ye, Kt;
function G() {
  if (Kt) return Ye;
  Kt = 1;
  function e(r) {
    return r != null && typeof r == "object";
  }
  return Ye = e, Ye;
}
var Ze, kt;
function On() {
  if (kt) return Ze;
  kt = 1;
  var e = M(), r = G(), t = "[object Arguments]";
  function a(n) {
    return r(n) && e(n) == t;
  }
  return Ze = a, Ze;
}
var er, Ut;
function jn() {
  if (Ut) return er;
  Ut = 1;
  var e = On(), r = G(), t = Object.prototype, a = t.hasOwnProperty, n = t.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(u) {
    return r(u) && a.call(u, "callee") && !n.call(u, "callee");
  };
  return er = i, er;
}
var D = { exports: {} }, rr, Bt;
function En() {
  if (Bt) return rr;
  Bt = 1;
  function e() {
    return !1;
  }
  return rr = e, rr;
}
D.exports;
var zt;
function wa() {
  return zt || (zt = 1, function(e, r) {
    var t = P(), a = En(), n = r && !r.nodeType && r, i = n && !0 && e && !e.nodeType && e, u = i && i.exports === n, s = u ? t.Buffer : void 0, c = s ? s.isBuffer : void 0, o = c || a;
    e.exports = o;
  }(D, D.exports)), D.exports;
}
var tr, Wt;
function wn() {
  if (Wt) return tr;
  Wt = 1;
  var e = 9007199254740991, r = /^(?:0|[1-9]\d*)$/;
  function t(a, n) {
    var i = typeof a;
    return n = n ?? e, !!n && (i == "number" || i != "symbol" && r.test(a)) && a > -1 && a % 1 == 0 && a < n;
  }
  return tr = t, tr;
}
var ar, $t;
function Pa() {
  if ($t) return ar;
  $t = 1;
  var e = 9007199254740991;
  function r(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= e;
  }
  return ar = r, ar;
}
var nr, Jt;
function Pn() {
  if (Jt) return nr;
  Jt = 1;
  var e = M(), r = Pa(), t = G(), a = "[object Arguments]", n = "[object Array]", i = "[object Boolean]", u = "[object Date]", s = "[object Error]", c = "[object Function]", o = "[object Map]", _ = "[object Number]", f = "[object Object]", m = "[object RegExp]", T = "[object Set]", A = "[object String]", y = "[object WeakMap]", p = "[object ArrayBuffer]", b = "[object DataView]", v = "[object Float32Array]", R = "[object Float64Array]", h = "[object Int8Array]", C = "[object Int16Array]", g = "[object Int32Array]", d = "[object Uint8Array]", S = "[object Uint8ClampedArray]", I = "[object Uint16Array]", j = "[object Uint32Array]", l = {};
  l[v] = l[R] = l[h] = l[C] = l[g] = l[d] = l[S] = l[I] = l[j] = !0, l[a] = l[n] = l[p] = l[i] = l[b] = l[u] = l[s] = l[c] = l[o] = l[_] = l[f] = l[m] = l[T] = l[A] = l[y] = !1;
  function O(q) {
    return t(q) && r(q.length) && !!l[e(q)];
  }
  return nr = O, nr;
}
var ir, Qt;
function xn() {
  if (Qt) return ir;
  Qt = 1;
  function e(r) {
    return function(t) {
      return r(t);
    };
  }
  return ir = e, ir;
}
var L = { exports: {} };
L.exports;
var Vt;
function Dn() {
  return Vt || (Vt = 1, function(e, r) {
    var t = Sa(), a = r && !r.nodeType && r, n = a && !0 && e && !e.nodeType && e, i = n && n.exports === a, u = i && t.process, s = function() {
      try {
        var c = n && n.require && n.require("util").types;
        return c || u && u.binding && u.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(L, L.exports)), L.exports;
}
var ur, Xt;
function xa() {
  if (Xt) return ur;
  Xt = 1;
  var e = Pn(), r = xn(), t = Dn(), a = t && t.isTypedArray, n = a ? r(a) : e;
  return ur = n, ur;
}
var sr, Yt;
function Ln() {
  if (Yt) return sr;
  Yt = 1;
  var e = In(), r = jn(), t = xr(), a = wa(), n = wn(), i = xa(), u = Object.prototype, s = u.hasOwnProperty;
  function c(o, _) {
    var f = t(o), m = !f && r(o), T = !f && !m && a(o), A = !f && !m && !T && i(o), y = f || m || T || A, p = y ? e(o.length, String) : [], b = p.length;
    for (var v in o)
      (_ || s.call(o, v)) && !(y && // Safari 9 has enumerable `arguments.length` in strict mode.
      (v == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      T && (v == "offset" || v == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      A && (v == "buffer" || v == "byteLength" || v == "byteOffset") || // Skip index properties.
      n(v, b))) && p.push(v);
    return p;
  }
  return sr = c, sr;
}
var or, Zt;
function Mn() {
  if (Zt) return or;
  Zt = 1;
  var e = Object.prototype;
  function r(t) {
    var a = t && t.constructor, n = typeof a == "function" && a.prototype || e;
    return t === n;
  }
  return or = r, or;
}
var cr, ea;
function Gn() {
  if (ea) return cr;
  ea = 1;
  function e(r, t) {
    return function(a) {
      return r(t(a));
    };
  }
  return cr = e, cr;
}
var fr, ra;
function Hn() {
  if (ra) return fr;
  ra = 1;
  var e = Gn(), r = e(Object.keys, Object);
  return fr = r, fr;
}
var vr, ta;
function Nn() {
  if (ta) return vr;
  ta = 1;
  var e = Mn(), r = Hn(), t = Object.prototype, a = t.hasOwnProperty;
  function n(i) {
    if (!e(i))
      return r(i);
    var u = [];
    for (var s in Object(i))
      a.call(i, s) && s != "constructor" && u.push(s);
    return u;
  }
  return vr = n, vr;
}
var _r, aa;
function Fn() {
  if (aa) return _r;
  aa = 1;
  var e = Ia(), r = Pa();
  function t(a) {
    return a != null && r(a.length) && !e(a);
  }
  return _r = t, _r;
}
var hr, na;
function Kn() {
  if (na) return hr;
  na = 1;
  var e = Ln(), r = Nn(), t = Fn();
  function a(n) {
    return t(n) ? e(n) : r(n);
  }
  return hr = a, hr;
}
var dr, ia;
function kn() {
  if (ia) return dr;
  ia = 1;
  var e = An(), r = Sn(), t = Kn();
  function a(n) {
    return e(n, t, r);
  }
  return dr = a, dr;
}
var lr, ua;
function Un() {
  if (ua) return lr;
  ua = 1;
  var e = kn(), r = 1, t = Object.prototype, a = t.hasOwnProperty;
  function n(i, u, s, c, o, _) {
    var f = s & r, m = e(i), T = m.length, A = e(u), y = A.length;
    if (T != y && !f)
      return !1;
    for (var p = T; p--; ) {
      var b = m[p];
      if (!(f ? b in u : a.call(u, b)))
        return !1;
    }
    var v = _.get(i), R = _.get(u);
    if (v && R)
      return v == u && R == i;
    var h = !0;
    _.set(i, u), _.set(u, i);
    for (var C = f; ++p < T; ) {
      b = m[p];
      var g = i[b], d = u[b];
      if (c)
        var S = f ? c(d, g, b, u, i, _) : c(g, d, b, i, u, _);
      if (!(S === void 0 ? g === d || o(g, d, s, c, _) : S)) {
        h = !1;
        break;
      }
      C || (C = b == "constructor");
    }
    if (h && !C) {
      var I = i.constructor, j = u.constructor;
      I != j && "constructor" in i && "constructor" in u && !(typeof I == "function" && I instanceof I && typeof j == "function" && j instanceof j) && (h = !1);
    }
    return _.delete(i), _.delete(u), h;
  }
  return lr = n, lr;
}
var pr, sa;
function Bn() {
  if (sa) return pr;
  sa = 1;
  var e = x(), r = P(), t = e(r, "DataView");
  return pr = t, pr;
}
var gr, oa;
function zn() {
  if (oa) return gr;
  oa = 1;
  var e = x(), r = P(), t = e(r, "Promise");
  return gr = t, gr;
}
var yr, ca;
function Wn() {
  if (ca) return yr;
  ca = 1;
  var e = x(), r = P(), t = e(r, "Set");
  return yr = t, yr;
}
var br, fa;
function $n() {
  if (fa) return br;
  fa = 1;
  var e = x(), r = P(), t = e(r, "WeakMap");
  return br = t, br;
}
var qr, va;
function Jn() {
  if (va) return qr;
  va = 1;
  var e = Bn(), r = Pr(), t = zn(), a = Wn(), n = $n(), i = M(), u = Oa(), s = "[object Map]", c = "[object Object]", o = "[object Promise]", _ = "[object Set]", f = "[object WeakMap]", m = "[object DataView]", T = u(e), A = u(r), y = u(t), p = u(a), b = u(n), v = i;
  return (e && v(new e(new ArrayBuffer(1))) != m || r && v(new r()) != s || t && v(t.resolve()) != o || a && v(new a()) != _ || n && v(new n()) != f) && (v = function(R) {
    var h = i(R), C = h == c ? R.constructor : void 0, g = C ? u(C) : "";
    if (g)
      switch (g) {
        case T:
          return m;
        case A:
          return s;
        case y:
          return o;
        case p:
          return _;
        case b:
          return f;
      }
    return h;
  }), qr = v, qr;
}
var mr, _a;
function Qn() {
  if (_a) return mr;
  _a = 1;
  var e = _n(), r = Ea(), t = mn(), a = Un(), n = Jn(), i = xr(), u = wa(), s = xa(), c = 1, o = "[object Arguments]", _ = "[object Array]", f = "[object Object]", m = Object.prototype, T = m.hasOwnProperty;
  function A(y, p, b, v, R, h) {
    var C = i(y), g = i(p), d = C ? _ : n(y), S = g ? _ : n(p);
    d = d == o ? f : d, S = S == o ? f : S;
    var I = d == f, j = S == f, l = d == S;
    if (l && u(y)) {
      if (!u(p))
        return !1;
      C = !0, I = !1;
    }
    if (l && !I)
      return h || (h = new e()), C || s(y) ? r(y, p, b, v, R, h) : t(y, p, d, b, v, R, h);
    if (!(b & c)) {
      var O = I && T.call(y, "__wrapped__"), q = j && T.call(p, "__wrapped__");
      if (O || q) {
        var E = O ? y.value() : y, w = q ? p.value() : p;
        return h || (h = new e()), R(E, w, b, v, h);
      }
    }
    return l ? (h || (h = new e()), a(y, p, b, v, R, h)) : !1;
  }
  return mr = A, mr;
}
var Tr, ha;
function Vn() {
  if (ha) return Tr;
  ha = 1;
  var e = Qn(), r = G();
  function t(a, n, i, u, s) {
    return a === n ? !0 : a == null || n == null || !r(a) && !r(n) ? a !== a && n !== n : e(a, n, i, u, t, s);
  }
  return Tr = t, Tr;
}
var Ar, da;
function Xn() {
  if (da) return Ar;
  da = 1;
  var e = Vn();
  function r(t, a) {
    return e(t, a);
  }
  return Ar = r, Ar;
}
var Yn = Xn();
const Zn = /* @__PURE__ */ Ra(Yn);
function la(e = window.innerWidth) {
  return {
    hover: matchMedia ? matchMedia("(hover)").matches : !0,
    isPhone: e <= 767,
    isTablet: e <= 1023,
    isAboveTablet: e > 1023,
    isLaptop: e <= 1199,
    isDesktop: e >= 1200,
    isDesktopWithDash: e >= 1450,
    isMidDesktop: e <= 1400
  };
}
const ei = (e) => Da(
  (r, t) => Zn(r, t) ? r : t,
  void 0,
  () => e()
), _i = () => {
  const [e, r] = ei(() => la());
  return Er(() => {
    const t = () => r(la());
    return window.addEventListener("resize", t), () => window.removeEventListener("resize", t);
  }, [r]), e;
}, ri = (e) => {
  const r = Aa(e);
  return Er(() => {
    r.current = e;
  }, [e]), La((...t) => {
    var a;
    return (a = r.current) == null ? void 0 : a.call(r, ...t);
  }, [r]);
}, pa = (e, r) => !!e && r.target instanceof Element && e.contains(r.target), hi = (e, r) => {
  const t = ri(r);
  Er(() => {
    let a = !1;
    const n = (u) => {
      a || pa(e.current, u) || t(u);
    }, i = (u) => {
      a = pa(e.current, u);
    };
    return document.addEventListener("mousedown", i), document.addEventListener("touchstart", i), document.addEventListener("click", n, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("touchstart", i), document.removeEventListener("click", n, !0);
    };
  }, [e, t]);
};
var Rr, ga;
function ti() {
  if (ga) return Rr;
  ga = 1;
  var e = P(), r = function() {
    return e.Date.now();
  };
  return Rr = r, Rr;
}
var Cr, ya;
function ai() {
  if (ya) return Cr;
  ya = 1;
  var e = /\s/;
  function r(t) {
    for (var a = t.length; a-- && e.test(t.charAt(a)); )
      ;
    return a;
  }
  return Cr = r, Cr;
}
var Sr, ba;
function ni() {
  if (ba) return Sr;
  ba = 1;
  var e = ai(), r = /^\s+/;
  function t(a) {
    return a && a.slice(0, e(a) + 1).replace(r, "");
  }
  return Sr = t, Sr;
}
var Ir, qa;
function ii() {
  if (qa) return Ir;
  qa = 1;
  var e = M(), r = G(), t = "[object Symbol]";
  function a(n) {
    return typeof n == "symbol" || r(n) && e(n) == t;
  }
  return Ir = a, Ir;
}
var Or, ma;
function ui() {
  if (ma) return Or;
  ma = 1;
  var e = ni(), r = k(), t = ii(), a = NaN, n = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, u = /^0o[0-7]+$/i, s = parseInt;
  function c(o) {
    if (typeof o == "number")
      return o;
    if (t(o))
      return a;
    if (r(o)) {
      var _ = typeof o.valueOf == "function" ? o.valueOf() : o;
      o = r(_) ? _ + "" : _;
    }
    if (typeof o != "string")
      return o === 0 ? o : +o;
    o = e(o);
    var f = i.test(o);
    return f || u.test(o) ? s(o.slice(2), f ? 2 : 8) : n.test(o) ? a : +o;
  }
  return Or = c, Or;
}
var jr, Ta;
function si() {
  if (Ta) return jr;
  Ta = 1;
  var e = k(), r = ti(), t = ui(), a = "Expected a function", n = Math.max, i = Math.min;
  function u(s, c, o) {
    var _, f, m, T, A, y, p = 0, b = !1, v = !1, R = !0;
    if (typeof s != "function")
      throw new TypeError(a);
    c = t(c) || 0, e(o) && (b = !!o.leading, v = "maxWait" in o, m = v ? n(t(o.maxWait) || 0, c) : m, R = "trailing" in o ? !!o.trailing : R);
    function h(q) {
      var E = _, w = f;
      return _ = f = void 0, p = q, T = s.apply(w, E), T;
    }
    function C(q) {
      return p = q, A = setTimeout(S, c), b ? h(q) : T;
    }
    function g(q) {
      var E = q - y, w = q - p, H = c - E;
      return v ? i(H, m - w) : H;
    }
    function d(q) {
      var E = q - y, w = q - p;
      return y === void 0 || E >= c || E < 0 || v && w >= m;
    }
    function S() {
      var q = r();
      if (d(q))
        return I(q);
      A = setTimeout(S, g(q));
    }
    function I(q) {
      return A = void 0, R && _ ? h(q) : (_ = f = void 0, T);
    }
    function j() {
      A !== void 0 && clearTimeout(A), p = 0, _ = y = f = A = void 0;
    }
    function l() {
      return A === void 0 ? T : I(r());
    }
    function O() {
      var q = r(), E = d(q);
      if (_ = arguments, f = this, y = q, E) {
        if (A === void 0)
          return C(y);
        if (v)
          return clearTimeout(A), A = setTimeout(S, c), h(y);
      }
      return A === void 0 && (A = setTimeout(S, c)), T;
    }
    return O.cancel = j, O.flush = l, O;
  }
  return jr = u, jr;
}
var oi = si();
const ci = /* @__PURE__ */ Ra(oi), di = (e, r) => {
  const t = Aa(e);
  return t.current = e, Ma(() => ci((...n) => t.current(...n), r), [r]);
};
export {
  hi as a,
  di as b,
  ri as c,
  pa as i,
  _i as u
};
